




































import {Component, Prop, Vue} from 'vue-property-decorator'
import BusinessCondition from '@/domain/BusinessCondition'
import {PortfolioSituationService, PortfolioSituation} from '@/domain/PortfolioSituation'
import ConditionList from '@/components/ConditionList.vue'
import Dialog from '@/components/Dialog.vue'
import Const from '@/util/Const'
import Indicator from '@/components/Indicator.vue'
import {State} from '@/views/diagnosis/Index.vue'

@Component({
  components: {ConditionList, Dialog, Indicator},
})
export default class Q1 extends Vue {

  @Prop({type: Object, required: true})
  public state!: State

  private data: Data = {bc: undefined}
  private situations: PortfolioSituation[] = []

  private con = Const

  public mounted() {
    const q1 = this.state.q1
    if (!q1) {
      return
    }

    this.data.bc = BusinessCondition.find(q1)

    // @ts-ignore
    this.$refs.indicator.change(1, true)
  }

  public async created() {
    this.situations = (await PortfolioSituationService.getSituations()).situations
  }

  public next() {
    this.$emit('setState', {q1: this.data.bc!.code})
    this.$router.push({path: './q2', query: {...this.state}})
  }

  private selectCondition(bc: BusinessCondition | undefined) {
    this.data.bc = bc

    // @ts-ignore
    this.$refs.indicator.change(1, false)
  }

  get bc(): BusinessCondition | undefined {
    return this.data.bc
  }
}

interface Data {
  bc: BusinessCondition | undefined
}
